import { useAuth } from "@/lib/auth-context";
import CompradorCotacoes from "./comprador/cotacoes";
import ProdutorCotacoes from "./produtor/cotacoes";

/**
 * COTAÇÕES — a MESMA rota para os dois lados do balcão.
 *
 * ⚠️ Quem decide o conteúdo é `organizations.tipo`, aqui, como na home e no "A
 * receber". E a razão vale dobrado nesta tela: o preço da praça é UM só, público,
 * igual para quem vende e para quem compra. Duas URLs para "quanto a praça está
 * pagando" seriam dois lugares para o link errado apontar, e dois lugares para o
 * número divergir.
 *
 * O que muda entre os dois é o que cada um cruza com a placa: o produtor, as
 * vendas dele; o comprador, nada ainda — ele não vende nessa praça. Ver o
 * comentário de `comprador/cotacoes.tsx`.
 */
export default function MercadoCotacoesPage() {
  const { user } = useAuth();
  return user?.orgTipo === "COMPRADOR" ? <CompradorCotacoes /> : <ProdutorCotacoes />;
}
